import { UserPermissions, PermissionEnum } from '@creditsights/api-ui-web';

export enum FeaturePermissionEnum {
  DOCKETS = 'ui:dockets',
  RISK_PRODUCTS = 'ui:risk_products',
  FINANCIALS = 'ui:financials',
}

export const hasPermissionToPrint = (userPermissions?: UserPermissions): boolean =>
  !!userPermissions && userPermissions.permissions.includes(PermissionEnum.PRINT);
export const hasPermissionToDownload = ({ permissions }: UserPermissions): boolean =>
  permissions.includes(PermissionEnum.DOWNLOAD_CONTENT);
export const hasPermissionToShare = ({ permissions }: UserPermissions): boolean =>
  permissions.includes(PermissionEnum.SHARE_CONTENT);
export const hasPermissionToAskAnAnalyst = ({ permissions }: UserPermissions): boolean =>
  permissions.includes(PermissionEnum.ASK_AN_ANALYST);
export const hasPermissionToCopyPaste = (userPermissions?: UserPermissions): boolean =>
  !!userPermissions && userPermissions.permissions.includes(PermissionEnum.COPY_PASTE);
export const hasPermissionToRP = (userPermissions?: UserPermissions): boolean =>
  !!userPermissions && userPermissions.permissions.includes(FeaturePermissionEnum.RISK_PRODUCTS);
export const hasPermissionToDockets = (userPermissions?: UserPermissions): boolean =>
  !!userPermissions && userPermissions.permissions.includes(FeaturePermissionEnum.DOCKETS);
export const hasPermissionToViewDocketDocument = (userPermissions?: UserPermissions): boolean =>
  !!userPermissions && userPermissions.permissions.includes('dockets:view_document');
export const hasPermissionToRequestDocketDocument = (userPermissions?: UserPermissions): boolean =>
  !!userPermissions && userPermissions.permissions.includes('dockets:request_document');
export const hasNoPermissionToDocketDocument = (userPermissions?: UserPermissions): boolean =>
  !hasPermissionToViewDocketDocument(userPermissions) && !hasPermissionToRequestDocketDocument(userPermissions);
export const hasNoPermissionToFinancials = (userPermissions?: UserPermissions): boolean =>
  !hasPermissionToFinancials(userPermissions);
export const hasPermissionToFinancials = (userPermissions?: UserPermissions): boolean =>
  !!userPermissions && userPermissions.permissions.includes(FeaturePermissionEnum.FINANCIALS);
export const hasPermissionToFinancialsExcelDownload = (userPermissions?: UserPermissions): boolean =>
  !!userPermissions && userPermissions.permissions.includes('ui:financials:download:excel');
